"use client"

import { useState, useEffect } from "react"

const PolicyClient = () => {
  const [currentLanguage, setCurrentLanguage] = useState("fr")
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false)

  const languages = [
    { code: "fr", name: "Français", flag: "/images/fr-flag-v2.png" },
    { code: "en", name: "English", flag: "/images/en-flag-v2.png" },
    { code: "ar", name: "العربية", flag: "/images/ar-flag-v2.png" },
  ]

  const translations = {
    fr: {
      back: "Retour",
      ecoTitle: "Comment nous rendons votre séjour plus écologique",
      ecoText:
        "L'harmonie est toujours une musique à nos oreilles et constitue la base du déploiement de notre mouvement de développement durable:",
      sustainableStaysTitle: "Séjours durables",
      sustainableStaysText:
        "Nos efforts continus en matière de développement durable visent à réduire les émissions de gaz à effet de serre et à accroître la participation à l'économie circulaire. Par exemple, nombre de nos hôtels ont opté pour des sources d'énergie plus propres et/ou ont éliminé les plastiques à usage unique.",
      foodCycleTitle: "Cycle alimentaire responsable",
      foodCycleText:
        "Nous écoutons les rythmes de la Terre et de ses habitants pour inspirer nos choix. Nous cherchons à protéger la biodiversité, à minimiser notre impact environnemental et à réduire le gaspillage alimentaire. Sur le plan social, nous entretenons des partenariats équitables avec nos agriculteurs locaux et nos fournisseurs partenaires.",
      localAssistanceTitle: "Assistance locale",
      localAssistanceText:
        "Nos hôtels sont comme des musiciens: ils aiment jouer en harmonie avec leur environnement. Nous nous engageons à améliorer nos communautés locales en protégeant leur culture et leur environnement (souvent grâce à des partenariats avec des ONG), en établissant des relations solides et en créant des opportunités économiques.",
      ibisLocationTitle: "À ibis Sfax",
      ibisLocationSubtitle: "nous construisons un avenir plus durable en :",
      ecoGestures: [
        "Optimiser l'efficacité énergétique",
        "Opter pour une énergie plus propre",
        "Conservation de l'eau",
        "Réduire les déchets et recycler",
        "Éliminer les plastiques à usage unique",
        "S'approvisionner en aliments de manière responsable",
        "Réduire le gaspillage alimentaire",

      ],
      certificationTitle: "Certification et engagement continu",
      certificationText:
        "Nos efforts en matière de développement durable incluent l'obtention d'une certification  greenKey. Ce label est décerné chaque année par un jury indépendant d'experts en environnement et en tourisme aux hébergements qui répondent à ces exigences rigoureuses. Par ailleurs, la conformité est régulièrement vérifiée et des améliorations continues sont encouragées. Soyez assurés que nous maintiendrons le cap sur nos objectifs. Pour plus d'informations sur Green Key, visitez https://www.greenkey.global/.",
      contact: "Contact",
      address: "Adresse",
      reservations: "Réservations",
      wifi: "Wi-Fi",
      network: "Réseau",
      password: "Mot de passe",
      availableAtReception: "Réseau Accor",
      followUs: "Suivez-nous",
      allRightsReserved: "Tous droits réservés",
      createdBy: "Créé par",
      addressLine1: "Avenue Majida Boulilla",
      addressLine2: "3000 SFAX, Tunisie",
    },
    en: {
      back: "Back",
      ecoTitle: "How we make your stay more ecological",
      ecoText: "Harmony is always music to our ears and forms the basis of our sustainable development movement:",
      sustainableStaysTitle: "Sustainable Stays",
      sustainableStaysText:
        "Our continuous efforts in sustainable development aim to reduce greenhouse gas emissions and increase participation in the circular economy. For example, many of our hotels have opted for cleaner energy sources and/or eliminated single-use plastics.",
      foodCycleTitle: "Responsible Food Cycle",
      foodCycleText:
        "We listen to the rhythms of the Earth and its inhabitants to inspire our choices. We seek to protect biodiversity, minimize our environmental impact and reduce food waste. Socially, we maintain fair partnerships with our local farmers and partner suppliers.",
      localAssistanceTitle: "Local Assistance",
      localAssistanceText:
        "Our hotels are like musicians: they love to play in harmony with their environment. We are committed to improving our local communities by protecting their culture and environment (often through partnerships with NGOs), establishing strong relationships and creating economic opportunities.",
      ibisLocationTitle: "At ibis Sfax",
      ibisLocationSubtitle: "we are building a more sustainable future in :",
      ecoGestures: [
        "Optimize energy efficiency",
        "Opt for cleaner energy",
        "Water conservation",
        "Reduce waste and recycle",
        "Eliminate single-use plastics",
        "Source food responsibly",
        "Reduce food waste",
        "Promote healthy and sustainable eating",
        "Preserve ecosystems and biodiversity",
        "Protect local communities and culture",
        "Encourage participation in sustainable development",
      ],
      certificationTitle: "Certification and Continuous Commitment",
      certificationText:
        "Our sustainable development efforts include obtaining an greenKey certification. This label is awarded annually by an independent jury of environmental and tourism experts to accommodations that meet these rigorous requirements. Furthermore, compliance is regularly verified and continuous improvements are encouraged. Rest assured that we will stay the course on our objectives. For more information about greenKey, visit https://www.greenkey.global/ .",
      contact: "Contact",
      address: "Address",
      reservations: "Reservations",
      wifi: "Wi-Fi",
      network: "Network",
      password: "Password",
      availableAtReception: "accor network",
      followUs: "Follow us",
      allRightsReserved: "All rights reserved",
      createdBy: "Created by",
      addressLine1: "Avenue Majida Boulilla",
      addressLine2: "3000 SFAX, Tunisia",
    },
    ar: {
      back: "رجوع",
      ecoTitle: "كيف نجعل إقامتك أكثر صديقة للبيئة",
      ecoText: "الانسجام هو دائماً موسيقى لآذاننا ويشكل أساس حركتنا للتنمية المستدامة:",
      sustainableStaysTitle: "الإقامات المستدامة",
      sustainableStaysText:
        "تهدف جهودنا المستمرة في التنمية المستدامة إلى تقليل انبعاثات غازات الدفيئة وزيادة المشاركة في الاقتصاد الدائري. على سبيل المثال، اختارت العديد من فنادقنا مصادر طاقة أنظف و/أو ألغت البلاستيك أحادي الاستخدام.",
      foodCycleTitle: "دورة غذائية مسؤولة",
      foodCycleText:
        "نستمع إلى إيقاعات الأرض وسكانها لإلهام خياراتنا. نسعى إلى حماية التنوع البيولوجي وتقليل تأثيرنا البيئي وتقليل هدر الطعام. على الصعيد الاجتماعي، نحافظ على شراكات عادلة مع مزارعينا المحليين وموردينا الشركاء.",
      localAssistanceTitle: "المساعدة المحلية",
      localAssistanceText:
        "فنادقنا مثل الموسيقيين: يحبون العزف بانسجام مع بيئتهم. نحن ملتزمون بتحسين مجتمعاتنا المحلية بحماية ثقافتهم وبيئتهم (غالباً من خلال الشراكات مع المنظمات غير الحكومية)، وإقامة علاقات قوية وخلق فرص اقتصادية.",
      ibisLocationTitle: "في فندق إيبيس صفاقس",
      ibisLocationSubtitle: "نحن نبني مستقبلاً أكثر استدامة",
      ecoGestures: [
        "تحسين كفاءة الطاقة",
        "اختيار طاقة أنظف",
        "الحفاظ على المياه",
        "تقليل النفايات وإعادة التدوير",
        "القضاء على البلاستيك أحادي الاستخدام",
        "الحصول على الغذاء بمسؤولية",
        "تقليل هدر الطعام",
        "تعزيز الأكل الصحي والمستدام",
        "الحفاظ على النظم البيئية والتنوع البيولوجي",
        "حماية المجتمعات المحلية والثقافة",
        "تشجيع المشاركة في التنمية المستدامة",
      ],
      certificationTitle: "الشهادة والالتزام المستمر",
      certificationText:
        "تشمل جهودنا في التنمية المستدامة الحصول على شهادة greenKey. يتم منح هذه العلامة سنوياً من قبل هيئة محلفين مستقلة من خبراء البيئة والسياحة للمنشآت التي تستوفي هذه المتطلبات الصارمة. علاوة على ذلك، يتم التحقق من الامتثال بانتظام وتشجيع التحسينات المستمرة. كن مطمئناً بأننا سنبقى على المسار الصحيح لتحقيق أهدافنا. للمزيد من المعلومات حول greenKey، قم بزيارة https://www.greenkey.global/ .",
      contact: "اتصال",
      address: "العنوان",
      reservations: "الحجوزات",
      wifi: "واي فاي",
      network: "الشبكة",
      password: "كلمة المرور",
      availableAtReception: "شبكة أكور",
      followUs: "تابعونا",
      allRightsReserved: "جميع الحقوق محفوظة",
      createdBy: "تم إنشاؤه بواسطة",
      addressLine1: "شارع محمد الخامس",
      addressLine2: "1001 تونس، تونس",
    },
  }

  const t = (key) => translations[currentLanguage][key] || key

  useEffect(() => {
    const savedLanguage = localStorage.getItem("IBIS-language")
    if (savedLanguage && translations[savedLanguage]) {
      setCurrentLanguage(savedLanguage)
      document.documentElement.dir = savedLanguage === "ar" ? "rtl" : "ltr"
      document.documentElement.lang = savedLanguage
    }
  }, [])

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode)
    localStorage.setItem("IBIS-language", langCode)
    setShowLanguageDropdown(false)
    document.documentElement.dir = langCode === "ar" ? "rtl" : "ltr"
    document.documentElement.lang = langCode
  }

  const getCurrentLanguage = () => languages.find((lang) => lang.code === currentLanguage)

  return (
    <div className={`hotel-app2 ${currentLanguage === "ar" ? "rtl" : "ltr"}`}>
      <style jsx>{`
        :root {
          --primary: #e72c3d;
          --primary-dark: #003d96;
          --secondary: #D4AF37;
          --background: #ffffff;
          --surface: #e72c3d;
          --text: #333333;
          --text-secondary: #666666;
          --border: #e0e0e0;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          background: var(--background);
          color: var(--text);
          line-height: 1.6;
        }

        .hotel-app2 {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .rtl .header-back-link {
          flex-direction: row-reverse;
        }

        .rtl .header-back-link svg {
          margin-left: 8px;
          margin-right: 0;
        }

        .logo-container {
          flex: 1;
          display: flex;
          justify-content: center;
        }

        .logo {
          height: 40px;
          width: auto;
        }

        .language-selector {
          position: absolute;
          top: 15px;
          left: 15px;
          z-index: 20;
        }
        
        .language-toggle {
          display: flex;
          align-items: center;
          gap: 8px;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          border: none;
          border-radius: 20px;
          padding: 8px 12px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.3s ease;
          backdrop-filter: blur(10px);
        }
        
        .language-toggle:hover {
          background: rgba(0, 0, 0, 0.8);
          transform: scale(1.05);
        }
        
        .language-flag {
          width: 20px;
          height: 15px;
          object-fit: cover;
          border-radius: 2px;
        }
        
        .language-dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          background: rgba(0, 0, 0, 0.9);
          border-radius: 8px;
          padding: 8px 0;
          min-width: 150px;
          z-index: 1000;
          backdrop-filter: blur(10px);
          margin-top: 5px;
        }
        
        .language-option {
          display: flex;
          align-items: center;
          padding: 8px 16px;
          cursor: pointer;
          transition: background-color 0.2s;
          gap: 8px;
          color: white;
          font-size: 14px;
        }
        
        .language-option:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        
        .language-option.active {
          background: rgba(255, 255, 255, 0.2);
        }
        
        .flag-small {
          width: 20px;
          height: 15px;
          object-fit: cover;
          border-radius: 2px;
        }

        .rtl {
          direction: rtl;
        }

        .rtl .language-selector {
          left: auto;
          right: 15px;
        }

        .rtl .language-dropdown {
          left: auto;
          right: 0;
          text-align: right;
        }

        .rtl .policy-content {
          text-align: right;
        }


        .rtl .copyright {
          text-align: right;
        }

        .rtl .copyright a {
          margin-left: 0;
          margin-right: 5px;
        }

        .policy-content {
          flex: 1;
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
          width: 100%;
        }

        .eco-section {
          margin-bottom: 3rem;
        }

        .eco-section-title {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary);
          margin-bottom: 1rem;
        }

        .eco-section-text {
          font-size: 1.1rem;
          color: var(--text);
          line-height: 1.8;
          margin-bottom: 2rem;
        }

        .top-image {
          width: 100%;
          max-width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 12px;
          margin-bottom: 2rem;
          display: block;
        }

        /* Changed eco-gestures-grid to single column layout */
        .eco-gestures-grid {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .eco-gesture-item {
          text-align: center;
        }

        .eco-gesture-image {
          width: 100%;
          max-width: 250px;
          height: 125px;
          object-fit: cover;
          border-radius: 8px;
          margin: 0 auto 1rem;
          display: block;
        }

        .eco-gesture-label {
          font-size: 0.95rem;
          color: white;
          font-weight: 500;
          line-height: 1.4;
        }

        .red-background-section {
          background: var(--primary);
          padding: 3rem 2rem;
          margin: 3rem -2rem;
          border-radius: 0;
        }

        .red-section-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .red-section-title {
          font-size: 2rem;
          font-weight: 700;
          color: white;
          margin-bottom: 0.5rem;
        }

        .red-section-subtitle {
          font-size: 1.3rem;
          font-weight: 500;
          color: white;
          margin-bottom: 2rem;
        }

        .certification-section {
          background: white;
          padding: 3rem 2rem;
          margin: 3rem -2rem;
          border-radius: 0;
        }

        .certification-title {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary);
          margin-bottom: 1.5rem;
          text-align: center;
        }

        .certification-text {
          font-size: 1.1rem;
          color: var(--text);
          line-height: 1.8;
          text-align: center;
        }



        .social-links {
          display: flex;
          gap: 1rem;
        }

        .social-links a {
          color: rgba(255, 255, 255, 0.8);
          transition: color 0.2s ease;
        }

        .social-links a:hover {
          color: white;
        }

        .copyright {
          text-align: center;
          padding-top: 2rem;
          margin-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          color: rgba(255, 255, 255, 0.8);
        }

        .copyright a {
          color: white;
          text-decoration: none;
        }

        @media (max-width: 768px) {
          .app-header {
            padding: 1rem;
          }

          .policy-content {
            padding: 1rem;
          }

          .top-image {
            height: 200px;
          }

          .eco-gesture-image {
            height: 200px;
          }

          .red-background-section {
            margin: 2rem -1rem;
            padding: 2rem 1rem;
          }

          .certification-section {
            margin: 2rem -1rem;
            padding: 2rem 1rem;
          }
        }
      `}</style>

      <div className="language-selector">
        <button className="language-toggle" onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}>
          <img
            src={getCurrentLanguage()?.flag || "/placeholder.svg"}
            alt={getCurrentLanguage()?.name}
            className="language-flag"
          />
          <span>{getCurrentLanguage()?.code.toUpperCase()}</span>
        </button>
        {showLanguageDropdown && (
          <div className="language-dropdown">
            {languages.map((lang) => (
              <div
                key={lang.code}
                className={`language-option ${currentLanguage === lang.code ? "active" : ""}`}
                onClick={(e) => {
                  e.stopPropagation()
                  changeLanguage(lang.code)
                }}
              >
                <img src={lang.flag || "/placeholder.svg"} alt={lang.name} className="flag-small" />
                <span>{lang.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <header className="app-header">
        <button className="header-back-link" onClick={() => (window.location.href = "/Home")}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d={currentLanguage === "ar" ? "M5 12H19M19 12L12 5M19 12L12 19" : "M19 12H5M5 12L12 19M5 12L12 5"}
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {t("back")}
        </button>
        <div className="logo-container">
          <img src="/images/logo2.png" alt="Ibis Logo" className="logo" />
        </div>
        <div></div>
      </header>

      <main className="policy-content">
        <img src="/images/good_time.png" alt="Good time" className="top-image" />

        <div className="eco-section">
          <h2 className="eco-section-title">{t("ecoTitle")}</h2>
          <p className="eco-section-text">{t("ecoText")}</p>
        </div>

        <div className="eco-section">
          <h2 className="eco-section-title">{t("sustainableStaysTitle")}</h2>
          <p className="eco-section-text">{t("sustainableStaysText")}</p>
        </div>

        <div className="eco-section">
          <h2 className="eco-section-title">{t("foodCycleTitle")}</h2>
          <p className="eco-section-text">{t("foodCycleText")}</p>
        </div>

        <div className="eco-section">
          <h2 className="eco-section-title">{t("localAssistanceTitle")}</h2>
          <p className="eco-section-text">{t("localAssistanceText")}</p>
        </div>

        <div className="red-background-section">
          <div className="red-section-header">
            <h2 className="red-section-title">{t("ibisLocationTitle")}</h2>
            <p className="red-section-subtitle">{t("ibisLocationSubtitle")}</p>
          </div>
  <div style={{ width: "100%", height: "2px", backgroundColor: "white", margin: "20px 0" }}></div>
          <div className="eco-gestures-grid">
            {t("ecoGestures").map((gesture, index) => (
              <div key={index} className="eco-gesture-item">
                <img src={`/images/ecogeste/${index + 1}.png`} alt={gesture} className="eco-gesture-image" />
                <p className="eco-gesture-label">{gesture}</p>
              </div>
            ))}
          </div>
            <div style={{ width: "100%", height: "2px", backgroundColor: "white", margin: "20px 0" }}></div>
        </div>

        <div className="certification-section">
          <h2 className="certification-title">{t("certificationTitle")}</h2>
          <p className="certification-text">{t("certificationText")}</p>
        </div>
      </main>

      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>{t("contact")}</h4>
            <p>+216 70 241 000</p>
            <p>ha094@accor.com</p>
          </div>
          <div className="footer-section">
            <h4>{t("address")}</h4>
            <p>{t("addressLine1")}</p>
            <p>{t("addressLine2")}</p>
          </div>
          <div className="footer-section">
            <h4>{t("reservations")}</h4>
            <p>+216 70 241 000</p>
            <p>ha094@accor.com</p>
          </div>
          <div className="footer-section">
            <h4>{t("wifi")}</h4>
            <p>
                {t("availableAtReception")}
            </p>
          </div>
          <div className="footer-section">
            <h4>{t("followUs")}</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/ibissfax" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/ibis_sfax" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © {new Date().getFullYear()} IBIS Sfax. {t("allRightsReserved")}.
            <br />
            {t("createdBy")}{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/images/itbafa_logo_white.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default PolicyClient
